export const WA_NUMBER = "528122626718";
export const WA_DISPLAY = "+52 81 2262 6718";
export const CONTACT_EMAIL = "richard@menuthere.com";
export const DEFAULT_WA_TEXT = "Hola Richard, quiero activar MenuThere en mi restaurante";

export const waUrl = (text = DEFAULT_WA_TEXT) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const planWaText = (plan) => `${DEFAULT_WA_TEXT}. Me interesa el plan ${plan}.`;

export const emailUrl = (subject = "Quiero activar MenuThere en mi restaurante", body = "Hola Richard,\n\nQuiero activar MenuThere en mi restaurante.\n\nNombre:\nRestaurante:\nCiudad:\nWhatsApp:\nPlan que me interesa:\n\nGracias.") =>
  `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const leadWaText = ({ name, restaurant, city, event, plan }) => {
  let t = `${DEFAULT_WA_TEXT}. Soy ${name}`;
  if (restaurant) t += ` de ${restaurant}`;
  if (city) t += ` en ${city}`;
  if (plan) t += ` · Plan: ${plan}`;
  if (event) t += ` · Evento: ${event}`;
  return t;
};

export const mxn = (n) => n.toLocaleString("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 });
export const usd = (n) => n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
